import { LogicContext } from '@/logic/main/types';

export const getJackpotDrawerLayoutContent = async (
  context: LogicContext
) => {
  const { currentJackpotsV2, controllersData } = context;

  if (!controllersData.jackpotDrawer) {
    return {
      updates: [],
    };
  }

  const updates = controllersData.jackpotDrawer?.components?.map(
    ([id, entry]) => ({
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: { ...entry.properties, currentJackpotsV2 },
      },
    })
  );

  return {
    updates,
  };
};
